import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EditEntry } from "../../../entriesAPI";
import SingleComment from "./SingleComment";

interface Props {
  entry: EditEntry;
}

const Comments = ({ entry }: Props) => {
  const { t } = useTranslation();

  // Go through approvalStateChanges and show the lastest change that has comment (customer's feedback)
  const latestCustomerStatusChange = entry?.approvalStateChanges
    ?.filter((change) => change?.comment) // Filter out changes without a comment or with an empty string as the comment
    .sort((a, b) => b.timestamp - a.timestamp)[0]; // Sort by timestamp in descending order

  return (
    <Box
      sx={{
        display: "flex",
        fontFamily: "quicksand",
        flexDirection: "column",
        backgroundColor: "white",
        borderRadius: "12px",
        marginLeft: "16px",
        padding: "8px",
      }}
    >
      <Box
        sx={{
          margin: "16px 0px 0px 0px",
          fontFamily: "quicksand",
          fontWeight: "700",
          fontSize: "16px",
        }}
      >
        {`${t("hourEntries:comment")}`}
      </Box>

      {
        // Talent comment
        entry?.feedback && (
          <SingleComment
            name={entry.talentFirstName + " " + entry.talentLastName}
            comment={entry.feedback?.comment || ""}
            timeStamp={entry.feedback?.timestamp || 0}
            image={""}
          />
        )
      }

      {
        // Customer comment
        latestCustomerStatusChange && (
          <SingleComment
            name={
              latestCustomerStatusChange?.userFirstName &&
              latestCustomerStatusChange?.userLastName
                ? `${latestCustomerStatusChange.userFirstName} ${latestCustomerStatusChange.userLastName}`
                : t("hourEntries:CUSTOMER_ORG")
            }
            comment={latestCustomerStatusChange?.comment || ""}
            timeStamp={latestCustomerStatusChange?.timestamp || 0}
            image={""}
          />
        )
      }
    </Box>
  );
};

export default Comments;
